export default "__VITE_ASSET__BfBOTolO__"